import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Order, PickService } from '../../../core';
import { environment } from '../../../../environments/environment';
import { ModalConfirmationListComponent } from '../modal-confirmation-list/modal-confirmation-list.component';
import { SnackbarService } from '../snackbar/snackbar.service';
import { ModalSmallComponent } from '../../../picking/picking-shared/components/modal-small/modal-small.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  standalone: false,
  selector: 'app-picking-orders-assign-picker',
  templateUrl: './picking-orders-assign-picker.component.html',
  styleUrls: ['./picking-orders-assign-picker.component.scss'],
})
export class PickingOrdersAssignPickerComponent implements OnInit {
  /**
   * Title  of picking orders assign picker component
   */
  title = 'Asigna un pickeador';
  /**
   * Button to accept of picking orders assign picker component
   */
  buttonToAccept = 'Asignar';
  /**
   * Displayed columns of picking orders assign picker component
   */
  displayedColumns: string[];
  /**
   * Array order selected of picking orders assign picker component
   */
  arrayOrderSelected = [];
  /**
   * Picker selected of picking orders assign picker component
   */
  pickerSelected: string;
  /**
   * Data source of picking orders assign picker component
   */
  dataSource: MatTableDataSource<any>;
  /**
   * Orders  of picking orders assign picker component
   */
  orders: Order[];
  /**
   * Form  of picking orders assign picker component
   */
  form: FormGroup;
  /**
   * Configuration picking
   */
  pickingSetting: any;
  /**
   * Active button Select
   */
  buttonActive: Boolean;
  /**
   * Creates an instance of picking orders assign picker component.
   * @param data any
   * @param dialog MatDialog
   * @param pickService PickService
   * @param formBuilder FormBuilder
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public pickService: PickService,
    public formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
    public dialogRef: MatDialogRef<PickingOrdersAssignPickerComponent>,
    private cdr: ChangeDetectorRef
  ) { }
  /**
   * on init
   */
  ngOnInit() {
    this.buttonActive = false;
    this.arrayOrderSelected = [];
    this.displayedColumns = ['radioButton', 'pickerCode', 'pickerName'];
    this.pickingSetting = JSON.parse(localStorage.getItem(environment.settingPicking));
    if (this.pickingSetting && this.pickingSetting.pickingFood) this.displayedColumns.push('information')
    if (this.data) {
      this.getPickers();
      this.orders = this.data.listOrdersSelected;
      this.orders.forEach((list: any) => {
        const data = { orderId: list.id, dispatchNumber: list.serialNumber };
        this.arrayOrderSelected.push(data);
      });
    } else {
      this.getPickersAssigned();
    }
  }
  /**
   * Applys filter
   * @param filterValue string
   */
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  /**
   * Gets pickers
   */
  getPickers() {
    this.pickService
      .getPickers(this.data.listOrdersSelected[0].entityCode, this.data.isExternalUser ? true : false)
      .subscribe((response: any[]) => {
        if (response.length == 0) {
          this.snackbarService.show("No hay pickeadores con sesión activa.", 'warning');
        }
        response.sort((a, b) => a.firstName > b.firstName && 1 || -1)
        if (this.pickingSetting && this.pickingSetting.pickingFood)
          response.sort((a, b) => a.activePicking > b.activePicking && 1 || -1)
        this.dataSource = new MatTableDataSource(response);
        this.cdr.markForCheck();
      });
  }
  /**
   * Gets pickers assigned
   */
  getPickersAssigned() {
    this.pickService.getPickersAssined().subscribe((res: any) => {
      this.dataSource = new MatTableDataSource(res);
      this.cdr.markForCheck();
    });
  }
  /**
   * Radios change any
   * @param data
   */
  radioChange(data: any) {
    this.pickerSelected = data.id;
  }
  /**
   * Determines whether click accept on
   */
  onClickAccept() {
    this.buttonActive = true
    if (this.data) {
      if (this.data.readOnlyDialog) {
        this.closeDialog(this.pickerSelected);
        return;
      }
      this.onAssignPicker();
    } else {
      this.onOrdersDeallocate();
    }
  }

  closeDialog(pickerSelected) {
    this.dialogRef.close({ pickerSelected });
  }

  closeCancelDialog() {
    //this.pickService.passedEvents.emit(false);
    this.dialogRef.close(false);
  }

  /**
   * Determines whether orders deallocate on
   */
  onOrdersDeallocate() {
    this.pickService
      .postOrdersDeallocate({ pickerId: this.pickerSelected })
      .subscribe((res) => {
        this.dialog
          .open(ModalSmallComponent, {
            width: '500px',
            maxWidth: '80vw',
            data: {
              result: 'Listo!',
              type: 'success',
              text: res.message,
            },
          })
          .afterClosed()
          .subscribe(() => this.pickService.passedEvents.emit(true));
      });
  }

  /**
   * Determines whether click assign picker on
   */
  onAssignPicker() {
    this.pickService
      .updateAssignPicker(this.pickerSelected, this.arrayOrderSelected)
      .subscribe(
        (response: any) => {
          if (response) {
            if (response.details) {
              if (response.details.length > 0) {
                this.showExceptions(response.details, this.orders);
              }
              this.snackbarService.show(response.message, 'error');
            } else {
              let numberOrdersUpdated = '';
              response.numberOrderList.forEach(
                (element) => (numberOrdersUpdated += element + ' ')
              );
              this.dialog
                .open(ModalSmallComponent, {
                  width: '500px',
                  maxWidth: '80vw',
                  data: {
                    result: 'Listo!',
                    type: 'success',
                    text: `Se ${this.valueAsignaron(response.numberOrderList)} ${response.numberOrderList.length
                      } ${this.valuePedido(
                        response.numberOrderList
                      )} al pickeador <br><b>${response.fullNamePicker}(${response.pickerCode
                      })`,
                  },
                })
                .afterClosed()
                .subscribe(() => this.pickService.passedEvents.emit(response.fullNamePicker));
            }
          }
        },
        (error) => {
          this.showExceptions(error.detail, this.orders);
          this.snackbarService.show(error.message, 'error');
        }
      );
  }

  showExceptions(exceptions, orders) {
    const listOrders = this.filterAssignedOrders(exceptions, orders);
    this.dialog.open(ModalConfirmationListComponent, {
      data: {
        type: 'exceptionsInOrderAssignment',
        data: listOrders,
        config: {
          title: 'Listado de observaciones al asignar pedidos',
          hideButtons: true
        }
      }
    });
  }

  filterAssignedOrders(exceptions, orders): any[] {
    const listOrders = [];
    exceptions.forEach(exception => {
      const orderList = orders
        .filter(item => item.productLine === exception.field)
        .map(item => item.numberOrder);
      listOrders.push({
        orders: orderList,
        ...exception
      });
    });
    return listOrders;
  }
  /**
   * Values asignaron
   * @param value any
   * @returns string
   */
  private valueAsignaron(value: any): string {
    return value.length === 1 ? 'asigno' : 'asignaron';
  }
  /**
   * Values pedido
   * @param value any
   * @returns string
   */
  private valuePedido(value: any): string {
    return value.length === 1 ? 'pedido' : 'pedidos';
  }
}
